import { Campaign } from "Types/Campaign";

import { shortCampaign } from "./CampaignFormOption";

function getById(campaigns: Campaign[], campaignId: string): Campaign | undefined {
    return campaigns.find((campaign: Campaign) => campaign.id == campaignId);
}

export function getCampaignValues(campaigns: Campaign[] = [], campaignId: string) {
    const campaign = getById(campaigns, campaignId);
    return {
        state: campaign?.state,
        name: campaign?.name,
        friendlyId: campaign?.friendlyId,
        key: campaign?.id,
        label: shortCampaign(campaign || {}),
    };
}

export const getCampaignSMSContent = (campaigns: Campaign[] = [], campaignId: string) => {
    const campaign = getById(campaigns, campaignId);
    return campaign?.smsCampaign?.content;
};

export const getCampaignTitle = (campaigns: Campaign[] = [], campaignId: string) => {
    const campaign = getById(campaigns, campaignId);
    return campaign?.name;
};

export const getCampaignType = (campaigns: Campaign[] = [], campaignId: string) => {
    const campaign = getById(campaigns, campaignId);
    return campaign?.type;
};
